const requestMutators = (document) => {
  const moveOperation = ({
    source,
    destination
  }) => {
    if (!document || !document.paths) {
      return false;
    }
    const pathObject = document.paths[source.path];
    if (!pathObject) {
      return false;
    }
    const operation = pathObject[source.method];
    if (!operation) {
      return false;
    }
    const newPath = destination.path || source.path;
    const newMethod = destination.method || source.method;
    if (document.paths[newPath]?.[newMethod]) {
      console.warn(`Request already exists at ${newPath} with method ${newMethod}.`);
      return false;
    }
    delete pathObject[source.method];
    if (!document.paths[newPath]) {
      document.paths[newPath] = {};
    }
    document.paths[newPath][newMethod] = operation;
    return true;
  };
  const deleteRequest = ({ path, method }) => {
    if (!document) {
      return false;
    }
    const pathObject = document?.paths?.[path];
    if (!pathObject) {
      return false;
    }
    const operation = pathObject[method];
    if (!operation) {
      return false;
    }
    delete pathObject[method];
    return true;
  };
  return {
    moveRequest: moveOperation,
    deleteRequest
  };
};
export {
  requestMutators
};
//# sourceMappingURL=request.js.map
